import {ApiClient} from '@hconnect/apiclient'
import type {User} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'
import {useEffect} from 'react'
import {useNavigate} from 'react-router'

import {TasksApiPath} from '../../consts'
import {handleTasksError as handleError} from '../../utils'

const QueryKey = 'user'
const CACHE_TIME_IN_MS = 1000 * 60

export const useUserById = (
  id: string,
  options?: Omit<UseQueryOptions<User | undefined, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const navigate = useNavigate()

  const query = useQuery<User | undefined, AxiosError>({
    queryKey: [QueryKey, id],
    queryFn: async ({signal}) => {
      const path = `${TasksApiPath.USERS}/${id}`
      const {data} = await ApiClient.axiosInstance.get<User>(path, {signal})

      return data
    },
    gcTime: CACHE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })

  useEffect(() => {
    if (query.error) {
      handleError(query.error, navigate)
    }
  }, [query.error, navigate])

  return query
}
